export default "__VITE_ASSET__DGJF363c__"